import React from 'react'
import Flit from '../flit/Flit'

const TeamItem = () => {
  return (
    <div className=' flex flex-col relative w-full h-auto flex-wrap mb-10'>
      <div className=' container mx-auto w-full h-auto flex flex-col flex-wrap'>
        <div className=' flex flex-col flex-wrap mb-10 justify-center items-center'>
          <Flit />
        </div>
        <div className='flex flex-col flex-wrap justify-center items-center text-center'>
          <h3 className='text-2xl  font-iceberg text-white'>CBG-FOUNDER</h3>
          <p className=' text-xl  font-turrent text-gray-400'>Founder</p>
        </div>
      </div>
    </div>
  )
}

export default TeamItem